import React from "react";

const Empty = () => {
  return <div className="page-wrapper"></div>;
};

export default Empty;
